export var HomogenousGetTierCurrentStatusMapper = function (data) {
    var homogenourEntity = {
        rmName: "",
        raName: "",
        statusName: "",
        currentTier: "",
        suggestedTier: "",
        createdDate: "",
        updatedDate: "",
    };
    if (data && data.length > 0) {
        homogenourEntity = data[0];
    }
    return homogenourEntity;
};
